export default __webpack_public_path__ + "static/media/Scene 9.899eb1dc.webp";